import controller from './note-context.controller';
import template from './note-context.html';

export default {
	template,
	bindings: {
		disabled:    '<?ngDisabled',
		ctx:         '<ngModel',
		opened:      '=?',
		onDelete:    '&?',
		onSubmit:    '&?',
	},
	controller,
	require: {
		commentsCtrl: '^^?comments',
	},
};
